/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserExportInfo} from '../models/UserExportInfo';

export interface ExportUsers$Request {
    requestBody: Array<number>;
}

export interface ExportUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const exportUsersRequest = createAction<PayloadData<void, ExportUsers$Request>>('USERS_EXPORT__EXPORT_USERS__REQUEST');
export const exportUsersSuccess = createAction<PayloadData<Array<UserExportInfo>, ExportUsers$Request>>('USERS_EXPORT__EXPORT_USERS__SUCCESS');
export const exportUsersFailure = createAction<PayloadData<Error, ExportUsers$Request, true>>('USERS_EXPORT__EXPORT_USERS__FAILURE');

export const exportUsersActions = [
    exportUsersRequest,
    exportUsersSuccess,
    exportUsersFailure
] as const;

/**
 * Export info for a list of users by their IDs
 * @param {Array<number>} meta.requestBody List of unique user IDs to export
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const exportUsers = (meta: ExportUsers$Request, config?: ExportUsers$Config) => {
    return {
        CALL_API: {
            types: exportUsersActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/export`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

